import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getPayment, listPayments, reconcilePayment } from '../api/adminPayments.api';
import type { PaymentListParams } from '../types';

const keys = {
  all: ['admin', 'payments'] as const,
  list: (params: PaymentListParams) => [...keys.all, 'list', params] as const,
  detail: (id?: string | null) => [...keys.all, 'detail', id] as const,
};

export const usePaymentList = (params: PaymentListParams) =>
  useQuery({ queryKey: keys.list(params), queryFn: () => listPayments(params), staleTime: 10_000 });

export const usePaymentDetail = (publicId?: string | null) =>
  useQuery({
    queryKey: keys.detail(publicId),
    queryFn: () => getPayment(publicId as string),
    enabled: !!publicId,
  });

export const useReconcilePayment = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (publicId: string) => reconcilePayment(publicId),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
};
